import { InfoTooltip } from "../../../shared/InfoTooltip";

interface LegendColorIconProps {
    label: string;
    color: string;
    tooltip?: string;
}

export const LegendColorIcon: React.FC<LegendColorIconProps> = ({ label, color, tooltip }) => {
    return (
        <div key={label} className="custom-legend-item">
            <svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>{label}</title>
                <rect width="40" height="16" fill={color} />
            </svg>
            {label}
            {tooltip && <InfoTooltip text={tooltip} />}
        </div>
    );
};
